import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import ProfileHeader from '../../../components/ProfileHeader'
import { getTicketsByUnitId } from '../../../api/TicketsApi'
import ProfileBottomNav from '../../../components/ProfileBottomNav'
import {
  DataGridPremium,
  esES,
  GridColDef,
  GridEventListener, GridRenderCellParams,
} from '@asf-libs/x-data-grid-premium'
import { TOKEN_SO_KEY } from '../../../utils/accountUtils'
import {
  getSessionStorage,
  setSessionStorage,
} from '../../../utils/StorageUtil'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import IconButton from '@mui/material/IconButton'
import { Trans } from 'react-i18next'
import AddIcon from '@mui/icons-material/Add'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import ConsultService from './consultService'
import {
  MAINT_TYPE_EQ,
  MAINT_TYPE_PAINT,
  MAINT_TYPE_REPAIRS,
  MAINT_TYPE_SERVICE,
} from '../../../utils/generalConstants'
import Stack from '@mui/material/Stack'
import TicketDraftApi from '../../../api/TicketDraftApi'
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import  { FULL_MENU } from '../../../api/config/Constants'

export default function ConsultMaintenance() {
  const [value, setValue] = React.useState('1')
  const { domain, id } = useParams()
  const navigate = useNavigate()

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  //const user = getSessionStorage(USER_SO_KEY);
  const handleRequireAssistance = () => {
    if (!domain) return
    TicketDraftApi.post(domain).then((result) => {
      setSessionStorage('draft-maintenance', { domain: domain, ...result.data })
      navigate(`/web/create-maintenance`)
    })
  }

  const getColumns = () => {
    let columns: GridColDef[] = [
      {
        field: 'edit',
        headerName: '',
        width: 40,
        renderCell: (params: GridRenderCellParams<any>) => (
          <strong>
            <IconButton className="primary text" size="small" tabIndex={params.hasFocus ? 0 : -1} onClick={()=> handleRowClick(params.row.id)} >
              <BuildOutlinedIcon />
            </IconButton>
          </strong>
        ),
      },
      {
        field: 'title',
        headerName: 'Titulo',
        width: 260,
        align: 'left',
      },
      {
        field: 'date',
        headerName: 'Fecha',
        width: 100,
      },
      {
        field: 'status',
        headerName: 'Estado',
        width: 130,
      },
      {
        field: 'idTicket',
        headerName: 'Nro Ticket',
        width: 120,
      },

    ]

    return columns
  }

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!id) return
    let active = true

    ;(async () => {
      setLoading(true)
      await getTicketsByUnitId(id)
        .then((response) => {
          const dataRows = response?.data?.map((d: any, index: number) => {
            return {
              id: d.id,
              numberPlate: domain,
              idTicket: d.idTicket,
              userID: d.userID,
              title: d.title,
              status: d.status,
              company: d.company,
              date: moment(d.date).format('DD-MM-YYYY'),
            }
          })
          setRows(dataRows ? dataRows : [])
          setLoading(false)
        })
        .catch((e) => {
          console.log('Error', e)
        })

      if (!active) {
        return
      }
      setLoading(false)
    })()

    return () => {
      active = false
    }
  }, [domain])

  const handleRowClick = (params: { row: { id: any } }) => {
    navigate(`/web/authorize-maintenance/${params}`)
  }

  const handleBack = () => {
    navigate(-1)
  }


  return (
    <Box sx={{ background: '#F2F3F1' }}>
      <ProfileHeader></ProfileHeader>
      <Box sx={{ margin: '0 4%' }}>
        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
          mt={2}
        >
        {FULL_MENU =='true' && (<Box flexGrow="1">
            <h3><IconButton color="primary" onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton> Mantenimientos</h3>
          </Box>) }  
          <Box flexGrow="1" textAlign="right">
            <h3>{domain?.toUpperCase()}</h3>
          </Box>
        </Stack>

        <Box
          sx={{
            typography: 'body1',
            borderRadius: '16px',
            background: '#ffffff',
          }}
        >
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs"
                TabIndicatorProps={{
                  title: 'indicator',
                  //hidden: true,
                  sx: { backgroundColor: '#5EB07F', height: 3 },
                }}
                sx={{
                  '& button.Mui-selected': { fontWeight: 900 },
                }}
                centered
              >
                <Tab
                  label={
                    <Trans
                      i18nKey={`screens.consultMaintenance.application`}
                    ></Trans>
                  }
                  value="1"
                />
                <Tab
                  label={
                    <Trans
                      i18nKey={`screens.consultMaintenance.preventive`}
                    ></Trans>
                  }
                  value="2"
                />
                <Tab
                  label={
                    <Trans
                      i18nKey={`screens.consultMaintenance.corrective`}
                    ></Trans>
                  }
                  value="3"
                />
              </TabList>
            </Box>
            <TabPanel sx={{ p: 0 }} value="1">
              <div style={{ maxHeight: 250, overflow: 'auto' }}>
                <div style={{ width: '100%', height: '100%' }}>
                  <div style={{ flexGrow: 1 }}>
                    <DataGridPremium
                      localeText={
                        esES.components.MuiDataGrid.defaultProps.localeText
                      }
                      rows={rows}
                      autoHeight={true}
                      columns={getColumns()}
                      density="compact"
                      sx={{
                        border: 0,
                        '& .super-app-theme--header': {
                          fontWeight: '900',
                        },
                        '& .MuiDataGrid-row.Mui-selected': {
                          backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        },
                      }}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>

              {/* <Box
                borderRadius={5}
                sx={{
                  background: "#FFFFFF",
                  // height: (rows?.length + 1) * 50 + 100,
                  // pt: 1,
                  maxHeight: 'calc(100vh - 360px)'
                }}
              >
                <DataGridPremium
                  localeText={
                    esES.components.MuiDataGrid.defaultProps.localeText
                  }
                  rows={rows}
                  autoHeight={true}
                  columns={getColumns()}
                  sx={{
                    overflow: 'auto',
                    '.MuiDataGrid-virtualScroller': {
                      height: 'auto',
                      overflow: 'hidden',
                    },
                    '.MuiDataGrid-main > div:nth-child(2)': {
                      overflowY: 'auto !important',
                      flex: 'unset !important',
                    },
                    border: 0,
                    "& .super-app-theme--header": {
                      fontWeight: "900",
                    },
                    "& .MuiDataGrid-row.Mui-selected":{
                      backgroundColor:"rgba(25, 118, 210, 0.08)"
                    }
                  }}
                  onRowClick={handleRowClick}
                  loading={loading}
                />
              </Box>  */}
            </TabPanel>
            <TabPanel value="2">
              <ConsultService
                id={id}
                domain={domain}
                type={[MAINT_TYPE_SERVICE]}
              />
            </TabPanel>
            <TabPanel value="3">
              <ConsultService
                id={id}
                domain={domain}
                type={[MAINT_TYPE_REPAIRS, MAINT_TYPE_EQ, MAINT_TYPE_PAINT]}
              />
            </TabPanel>
          </TabContext>
        </Box>
        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <IconButton
            // disabled={!getSessionStorage(TOKEN_SO_KEY)}
            className="consult-maintenance-icon-button"
            onClick={handleRequireAssistance}
          >
            <AddIcon />
            <Trans
              i18nKey={`screens.consultMaintenance.newApplication`}
            ></Trans>
          </IconButton>
        </Box>
      </Box>
      <ProfileBottomNav />
    </Box>
  )
}
